export default function Textbox({ type = 'text', label, value, handleChange }) {
    return <div className="form-group">
        <label className="form-label mt-4">{label}</label>
        <input type={type} className="form-control" placeholder={label} value={value} onChange={e => handleChange(e.target.value)} />
    </div>
}
